import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
export const CookiePolicyPage = () => {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`} data-id="element-3829">
      <Navbar data-id="element-3830" />

      {/* Main Content */}
      <div className="pt-20 pb-16" data-id="element-3831">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3832">
          <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl shadow-lg p-8 md:p-12`} data-id="element-3833">
            <h1 className={`text-4xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3834">
              Cookie Policy
            </h1>

            <div className={`prose prose-lg max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-3835">
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3836">
                <strong data-id="element-3837">Effective Date:</strong> January 15, 2025
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3838">
                This Cookie Policy explains how MaestroConnect ("we," "us," or
                "our") uses cookies and similar technologies when you access or
                use our platform and services (collectively, the "Services").
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3839">
                1. What Are Cookies?
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3840">
                Cookies are small text files that are stored on your device
                (computer, tablet, or mobile phone) when you visit a website.
                They help websites remember your preferences, improve your
                experience, and provide essential functionality.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3841">
                Cookies can be "session cookies" (which are deleted when you
                close your browser) or "persistent cookies" (which remain on
                your device until they expire or you delete them).
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3842">
                2. How We Use Cookies
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3843">
                MaestroConnect currently uses cookies only for essential
                purposes required to operate the platform. We do not use cookies
                for advertising, tracking, or selling your data to third
                parties.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3844">
                3. Types of Cookies We Use
              </h2>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3845">
                3.1 Essential Cookies (Strictly Necessary)
              </h3>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-3846">
                These cookies are necessary for the Services to function
                properly and cannot be disabled. They include:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3847">
                <li data-id="element-3848">
                  <strong data-id="element-3849">Authentication & Session Management:</strong> Cookies
                  that keep you logged in and maintain your session as you
                  navigate the platform (e.g., Firebase authentication tokens).
                </li>
                <li data-id="element-3850">
                  <strong data-id="element-3851">Security & Fraud Prevention:</strong> Cookies that
                  help protect your account from unauthorized access and detect
                  suspicious activity.
                </li>
                <li data-id="element-3852">
                  <strong data-id="element-3853">Core Platform Functionality:</strong> Cookies that
                  enable essential features such as accessing your dashboard,
                  managing lessons, viewing student progress, and saving
                  settings.
                </li>
                <li data-id="element-3854">
                  <strong data-id="element-3855">Preference Storage:</strong> Cookies that remember
                  your preferences, such as theme mode (dark/light), language
                  settings, and display options.
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3856">
                These essential cookies do not require your consent under most
                privacy laws because they are necessary to provide the Services
                you have requested.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3857">
                3.2 Analytics Cookies (Not Currently Used)
              </h3>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3858">
                MaestroConnect does not currently use analytics cookies to track
                your usage or behavior on the platform. If we introduce
                analytics in the future, we will:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3859">
                <li data-id="element-3860">Use privacy-first, anonymous analytics tools</li>
                <li data-id="element-3861">Update this Cookie Policy to reflect the change</li>
                <li data-id="element-3862">
                  Implement a cookie consent banner if required by applicable
                  law
                </li>
                <li data-id="element-3863">
                  Provide clear options to opt out of non-essential analytics
                </li>
              </ul>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3864">
                3.3 Advertising & Tracking Cookies (Not Used)
              </h3>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3865">
                We do not use advertising cookies, tracking cookies, or
                third-party ad networks. We do not sell, share, or monetize your
                cookie data in any way.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3866">
                4. Third-Party Cookies
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3867">
                MaestroConnect does not currently allow third-party cookies on
                our platform, except for essential services required to operate
                the platform (such as Firebase for authentication and hosting).
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3868">
                These third-party services may set their own cookies to provide
                their functionality. We carefully select service providers that
                respect user privacy and comply with data protection
                regulations.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3869">
                5. Managing Your Cookie Preferences
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-3870">
                You can manage cookies through your browser settings. Most
                browsers allow you to:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3871">
                <li data-id="element-3872">View and delete cookies</li>
                <li data-id="element-3873">Block cookies from specific websites</li>
                <li data-id="element-3874">Block all third-party cookies</li>
                <li data-id="element-3875">Clear all cookies when you close your browser</li>
                <li data-id="element-3876">
                  Browse in "incognito" or "private" mode (which deletes cookies
                  when you close the window)
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3877">
                Please note that if you disable or block essential cookies, you
                may not be able to access certain features of the Services, such
                as logging in, saving preferences, or accessing your dashboard.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3878">
                For more information on how to manage cookies in your browser,
                visit:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3879">
                <li data-id="element-3880">
                  <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className={`${isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-700'} hover:underline`} data-id="element-3881">
                    Google Chrome
                  </a>
                </li>
                <li data-id="element-3882">
                  <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer" className={`${isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-700'} hover:underline`} data-id="element-3883">
                    Mozilla Firefox
                  </a>
                </li>
                <li data-id="element-3884">
                  <a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" target="_blank" rel="noopener noreferrer" className={`${isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-700'} hover:underline`} data-id="element-3885">
                    Safari
                  </a>
                </li>
                <li data-id="element-3886">
                  <a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className={`${isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-700'} hover:underline`} data-id="element-3887">
                    Microsoft Edge
                  </a>
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3888">
                6. User Consent
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3889">
                Because MaestroConnect currently uses only essential cookies
                required to operate the platform, we do not require your
                explicit consent to use these cookies under most privacy laws
                (including GDPR and CCPA).
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3890">
                If we introduce non-essential cookies in the future (such as
                analytics or marketing cookies), we will implement a cookie
                consent banner that allows you to accept or decline these
                cookies before they are set.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3891">
                7. Data Protection & Privacy
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3892">
                The information collected through cookies is subject to our{' '}
                <a href="/privacy-policy" className={`${isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-700'} hover:underline`} data-id="element-3893">
                  Privacy Policy
                </a>
                . We are committed to protecting your privacy and handling your
                data responsibly.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3894">
                We do not sell, rent, or share your cookie data with third
                parties for advertising or marketing purposes. We only use
                cookies to provide and improve the Services.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3895">
                8. Updates to This Cookie Policy
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3896">
                We may update this Cookie Policy from time to time to reflect
                changes in our practices, technology, or legal requirements. If
                we make material changes, we will notify you by:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3897">
                <li data-id="element-3898">Posting a notice on the Services</li>
                <li data-id="element-3899">Sending you an email notification</li>
                <li data-id="element-3900">Updating the "Effective Date" at the top of this policy</li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3901">
                Your continued use of the Services after the updated Cookie
                Policy takes effect constitutes your acceptance of the changes.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3902">
                9. Contact Us
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-3903">
                If you have questions or concerns about this Cookie Policy or
                how we use cookies, please contact us:
              </p>

              <div className={`${isDark ? 'bg-navy-700' : 'bg-gray-50'} p-6 rounded-lg mb-6`} data-id="element-3904">
                <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3905">
                  <strong data-id="element-3906">Email:</strong>{' '}
                  <a href="mailto:support@maestroconnect.com" className={`${isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} hover:underline`} data-id="element-3907">
                    support@maestroconnect.com
                  </a>
                </p>
              </div>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mt-8`} data-id="element-3908">
                Thank you for trusting MaestroConnect. We are committed to
                transparency and protecting your privacy while providing a
                high-quality platform for music education.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer data-id="element-3909" />
    </div>;
};